import * as React from "react";
import { useNavigate } from "react-router";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface YearInReviewCardProps {
    year?: number;
}

export default function YearInReviewCard({
    year,
}: YearInReviewCardProps): React.JSX.Element {
    const navigate = useNavigate();
    const displayYear = year ?? new Date().getFullYear();

    const handleClick = () => {
        navigate(`/stats/year-in-review/${displayYear}`);
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                cursor: "pointer",
                borderRadius: 2,
                overflow: "hidden",
                background: (theme) =>
                    `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.light} 100%)`,
                minHeight: 95,
                width: "100%",
                p: 2,
                display: "flex",
                alignItems: "center",
                position: "relative",
                "&:hover": {
                    "& .chevron": {
                        transform: "translateX(4px)",
                    },
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
            >
                <Stack spacing={0.5}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <AutoAwesomeIcon
                            sx={{
                                color: "secondary.main",
                                fontSize: 20,
                            }}
                        />
                        <Typography
                            variant="h5"
                            sx={{
                                color: "secondary.main",
                                fontWeight: "bold",
                                letterSpacing: 1,
                            }}
                        >
                            NEW
                        </Typography>
                    </Stack>
                    <Typography
                        variant="h4"
                        sx={{
                            color: "#fff",
                            fontWeight: "bold",
                        }}
                    >
                        {displayYear} Year in Review
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontSize: "0.75rem",
                        }}
                    >
                        See your training highlights and top workouts!
                    </Typography>
                </Stack>

                <ChevronRightIcon
                    className="chevron"
                    sx={{
                        color: "#fff",
                        fontSize: 32,
                        opacity: 0.7,
                        transition: "transform 0.2s ease",
                    }}
                />
            </Stack>
        </Box>
    );
}
